import {Component, ReactNode} from 'react';
import weirwood from '@/weirwood';

interface ErrorBoundaryProps {
    children?: ReactNode;
}

interface ErrorBoundaryState {
    hasError: boolean;
}

export default class SlotErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = {hasError: false};
    }

    static getDerivedStateFromError() {
        return {hasError: true};
    }

    componentDidCatch(error: Error) {
        try {
            if (typeof error === 'string' || !error) {
                error = new Error(error);
            }
            error.message = `plugin slot crashed for: ${error.message}`;
            // 上报wirewood
            weirwood && weirwood.error.captureException(error);
            // 去掉错误文案，改成控制台提示
            console.error('err:', error.message);
        } catch (err) {
            console.error('err: ', err);
        }
    }

    render() {
        if (this.state.hasError) {
            return <div></div>;
        }

        return (
            <>
                {this.props.children}
            </>
        );
    }
}
